export default __webpack_public_path__ + "static/media/elp-logo-black-min.b7b3756d.png";